export const TESTING_ASSIGNMENT_KIND = {
    QA: 'QA',
    RETEST: 'RETEST',
    LIVE_VERIFICATION: 'LIVE_VERIFICATION',
    UAT: 'UAT',
};
export const TESTING_ASSIGNMENT_STATUS = {
    PENDING: 'PENDING',
    IN_PROGRESS: 'IN_PROGRESS',
    PASSED: 'PASSED',
    FAILED: 'FAILED',
    CLARIFICATION: 'CLARIFICATION',
    CANCELLED: 'CANCELLED',
};
export const TEST_RESULT = {
    PASS: 'PASS',
    FAIL: 'FAIL',
};
export const TEST_ENVIRONMENT = {
    DEVELOPMENT: 'DEVELOPMENT',
    STAGING: 'STAGING',
    PRODUCTION: 'PRODUCTION',
};
/** Automated check (GitHub Actions) outcome as shown inside Ashniva Desk. */
export const CHECK_STATUS = {
    PENDING: 'PENDING',
    RUNNING: 'RUNNING',
    PASSED: 'PASSED',
    FAILED: 'FAILED',
    CANCELLED: 'CANCELLED',
};
//# sourceMappingURL=qa-status.js.map